import { Component, OnInit, Input, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { AppConstants } from 'app/app.constants';
import { IndexdbService } from 'app/core/services/indexdb.service';
import { ReportImages, ReportService } from 'app/core/services/report.service';
interface ImageData {
  imagem: {
    rasterImage: string;
    backgroundImage: string;
  };
}

@Component({
  standalone: true,
  selector: 'app-gestao-arquivo-card-image',
  imports: [CommonModule],
  templateUrl: 'gestao-arquivo-card-image.component.html',
  styleUrls: ['gestao-arquivo-card-image.component.scss'],
})
export class GestaoArquivoCardImageComponent implements OnInit {
  @Input() workId: string;
  @Input() statusChangeEventEmitter: EventEmitter<string>;
  @Input() imageData: ImageData;
  @Input() equipment: string;
  public graphcis = './assets/images/default/graphics.jpg';
  public noPhoto = './assets/images/default/no-photo.jpg';
  public defaultImage = '';
  public backgroundImage = '';
  public rasterImage = '';
  public indexDBBackgroundImages: string[] = [];
  public indexDBRasterImages: string[] = [];

  rasterImageB64IndexDB;
  bkgrndImageB64IndexDB;

  imagensDoIndexDataBase;

  constructor(
    public reportService: ReportService,
    private indexdbService: IndexdbService,
    public translateService: TranslateService,
  ) {}

  ngOnInit(): void {
    if (this.equipment === AppConstants.DEVICE_MODEL.SPRAYRATE.name) {
      this.defaultImage = this.graphcis;
    } else {
      this.defaultImage = this.noPhoto;
    }
    this.statusChangeEventEmitter?.subscribe((status) => {
      if (status === 'completed') {
        this.getImageThumbails();
      }
    });

    this.getImageThumbails();
  }

  private getImageThumbails() {
    this.indexdbService
      .getDataIndexDBById(this.workId)
      .then((res: ImageData | null) => {
        if (res?.imagem.backgroundImage && res?.imagem.rasterImage) {
          this.rasterImage = res?.imagem.rasterImage;
          this.backgroundImage = res?.imagem.backgroundImage;
        } else {
          if (this.workId) {
            this.reportService
              .getImageThumbnails(this.workId)
              .subscribe({
                next: (data: ReportImages) => {
                  this.backgroundImage = data.backgroundImages?.speed;
                  this.rasterImage = data.rasterImages?.speed;

                  if (this.backgroundImage)
                    this.backgroundImage =
                      'data:image/png;base64,' + this.backgroundImage;
                  if (this.rasterImage)
                    this.rasterImage =
                      'data:image/png;base64,' + this.rasterImage;

                  const imageObjects = {
                    rasterImage: `${this.rasterImage}`,
                    backgroundImage: `${this.backgroundImage}`,
                  };
                  this.indexdbService
                    .saveImage(this.workId, imageObjects)
                    .then(() => {})
                    .catch((error) => {
                      console.error(error);
                    });
                },
                error: () => {},
              });
          }
        }
      });
  }
}
